import { render } from "./TheSheetUpper.vue?vue&type=template&id=1c73103f"
import script from "./TheSheetUpper.vue?vue&type=script&lang=js"
export * from "./TheSheetUpper.vue?vue&type=script&lang=js"
script.render = render

export default script